import React, {Component} from 'react';
import styles from "./studentinfo.module.css";
import back from '../../img/ic_back.png';
import caiji from '../../img/ic_caiji.png';

import BadgeSmall from './badge/badgeSmall.jsx';
import BadgeLarge from './badge/badgeLarge.jsx';
import PieChart1 from './piechart1/pieChart1.jsx';
import PieChart2 from './piechart2/pieChart2.jsx';
import BarChart1 from './barchart1/barChart1.jsx';
import BarChart2 from './barchart2/barChart2.jsx';
import LineChart1 from './linechart1/lineChart1.jsx';
import LineChart2 from './linechart2/lineChart2.jsx';
import LineChart3 from './linechart3/lineChart3.jsx';
import BadgeRanking from './badgeRanking/badgeRanking.jsx';
import DianzanRanking from './dianzanRanking/dianzanRanking.jsx';
import FaceCollect from './faceCollect/faceCollect.jsx';



const Studentinfo = props => (

    <div className={styles.root}>


        <div className={styles.menubar}>
            <img className={styles["img-back"]} src={back} onClick={props.closeStudentinfoModal}/>
            <div className={styles["modal-title"]}>{sessionStorage.getItem('studentname')}</div>

            {
                sessionStorage.getItem('check_bzr')==1||sessionStorage.getItem('admin')=='1'?
                    <div className={styles["bt-report"]} onClick={props.openTermreportPrompt}>学期报告</div>
                    :null
            }

            <div className={styles["div-caiji"]} onClick={props.openFaceCollectPrompt}>
                <img className={styles["img-caiji"]} src={caiji} />
                <div>采集人脸</div>
            </div>
        </div>

        <div className={styles.container} id='root'>

            <div className={styles["container-top"]}>
                <div className={styles["container-top-left"]}>

                    <div className={styles["container-fengchao"]} >
                        {props.yemian=='1'?
                            <BadgeSmall
                                jihao={props.jihao}
                                hzsum={props.hzsum}/>:
                            null
                        }
                        {props.yemian=='2'?
                            <BadgeLarge
                                jihao={props.jihao}
                                hzsum={props.hzsum}/>:
                            null
                        }
                    </div>


                    <BarChart1
                        hzDzRankingData={props.hzDzRankingData}/>
                    <BarChart2/>


                </div>
                <div className={styles["container-top-right"]}>
                    <PieChart1/>
                    <PieChart2/>
                    <BadgeRanking/>
                    <DianzanRanking/>
                </div>

            </div>

            <div className={styles["text-green"]}>学期表现曲线</div>

            <div className={styles["container-linechart"]}>
                <LineChart1/>
                <LineChart2/>
            </div>

            {/*<div className={styles["text-green"]}>徽章点赞记录</div>*/}
            {/*<LineChart3/>*/}

            {props.showFaceCollectPrompt?
            <FaceCollect
                onCancel={props.onCancel}/>:null}

        </div>

    </div>

)

export default Studentinfo;
